export const OPEN_DOCUMENT_STORAGE_KEY = 'dms:openDocumentId'
